import { InferGetStaticPropsType } from 'next'

/* blocks */
import Layout from '@/cmp/templates/Layout/Layout'
import OrganicMarketingStack from '@/cmp/templates/OrganicMarketingStack/OrganicMarketingStack'

/* utils */
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import {
  productOrganicMarketingStackPageQuery,
  ProductOrganicMarketingStackPageResponse
} from '@/utils/queries/product/organic_marketing_stack'
import { TEN_MINS_REVALIDATION } from '@/utils/constants/revalidation'
import { constructMetadataFromStrapiData } from '@/utils/functions/strapi'
import { constructFaqJsonSchema } from '@/utils/functions/jsonSchema'

function OrganicMarketingStackPage({
  data
}: InferGetStaticPropsType<typeof getStaticProps>): JSX.Element {
  return (
    <Layout
      title={data.seo.title}
      meta={constructMetadataFromStrapiData(data.seo)}
      jsonSchema={[constructFaqJsonSchema(data.faqs)]}
      canonical="/product/organic-marketing-stack/"
    >
      <OrganicMarketingStack data={data} />
    </Layout>
  )
}
export const getStaticProps = async () => {
  const result =
    await getStrapiGraphqlData<ProductOrganicMarketingStackPageResponse>(
      productOrganicMarketingStackPageQuery.loc?.source.body
    )

  return {
    props: {
      data: result.productOrganicMarketingStack.data.attributes
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export default OrganicMarketingStackPage
